export default function BlogCardSkeleton() {
  return (
    <article className="flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
      <div className="w-full h-52 skeleton-shimmer" />
      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className="h-5 w-20 rounded-full skeleton-shimmer" />
          <div className="h-4 w-24 rounded-md skeleton-shimmer" />
        </div>
        <div className="h-5 w-full rounded-md skeleton-shimmer mb-2" />
        <div className="h-5 w-3/4 rounded-md skeleton-shimmer mb-3" />
        <div className="h-3.5 w-full rounded-md skeleton-shimmer mb-2" />
        <div className="h-3.5 w-full rounded-md skeleton-shimmer mb-2" />
        <div className="h-3.5 w-2/3 rounded-md skeleton-shimmer mb-3" />
        <div className="flex flex-wrap gap-1.5 mb-3">
          <div className="h-5 w-16 rounded-full skeleton-shimmer" />
          <div className="h-5 w-14 rounded-full skeleton-shimmer" />
          <div className="h-5 w-20 rounded-full skeleton-shimmer" />
        </div>
        <div className="flex items-center gap-2 mt-auto pt-3 border-t border-background-200/70">
          <div className="h-3.5 w-24 rounded-md skeleton-shimmer" />
          <div className="h-3.5 w-16 rounded-md skeleton-shimmer ml-auto" />
        </div>
      </div>
    </article>
  );
}